import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Constants } from './../../app.constants';
import { ErrorHandleService } from './error-handle.service';

@Injectable({
    providedIn: 'root',
})
export class ContentService {
    constructor(
        private http: HttpClient,
        private errorHandleService: ErrorHandleService,
        private constants: Constants
    ) {}

    getFAQs(): Observable<any> {
        const uri = decodeURIComponent(
            `${this.constants.apiUrl}/Search/getcontentbytype/3`
        );
        return this.http.get(uri).pipe(
            tap((_) => console.log('fetched faqs')),
            catchError(this.errorHandleService.handleError('getFAQs', []))
        );
    }

    getHelpDetails(articleId): Observable<any> {
        const uri = decodeURIComponent(
            `${this.constants.apiUrl}/Search/getcontent/${articleId}`
        );
        return this.http.get(uri).pipe(
            tap((_) => console.log('fetched help details')),
            catchError(
                this.errorHandleService.handleError('getHelpDetails', [])
            )
        );
    }

    getHelp(): Observable<any> {
        const uri = decodeURIComponent(
            `${this.constants.apiUrl}/Search/getcontentbytype/6`
        );
        return this.http.get(uri).pipe(
            tap((_) => console.log('fetched help')),
            catchError(this.errorHandleService.handleError('getHelp', []))
        );
    }

    getLinks(): Observable<any> {
        const uri = decodeURIComponent(
            `${this.constants.apiUrl}/Search/getcontentbytype/2`
        );
        return this.http.get(uri).pipe(
            tap((_) => console.log('fetched links')),
            catchError(this.errorHandleService.handleError('getLinks', []))
        );
    }

    getNews(count?: number): Observable<any> {
        let itemCount = '';
        if (count) {
            itemCount = '/' + count;
        }
        const uri = decodeURIComponent(
            `${this.constants.apiUrl}/Search/getcontentbytype/1${itemCount}`
        );
        return this.http.get(uri).pipe(
            tap((_) => console.log('fetched news')),
            catchError(this.errorHandleService.handleError('getNews', []))
        );
    }

    getNewsDetails(newsId): Observable<any> {
        const uri = decodeURIComponent(
            `${this.constants.apiUrl}/Search/getcontent/${newsId}`
        );
        return this.http.get(uri).pipe(
            tap((_) => console.log('fetched news details')),
            catchError(
                this.errorHandleService.handleError('getNewsDetails', [])
            )
        );
    }

    getDBUpdates(count?: number): Observable<any> {
        let itemCount = '';
        if (count) {
            itemCount = '/' + count;
        }
        const uri = decodeURIComponent(
            `${this.constants.apiUrl}/Search/getcontentbytype/5${itemCount}`
        );
        return this.http.get(uri).pipe(
            tap((_) => console.log('fetched db-updates')),
            catchError(this.errorHandleService.handleError('getDBUpdates', []))
        );
    }
}
